/* eslint prefer-template:0 */

import isLocal from '../common/isLocal.js'
import joinURL from '../common/joinURL.js'

export default function (window, versions, experiment) {
  function getViewerRjsConfig(serviceTopology) {
        //TODO: cancel fallback to staticServerUrl when server is stable
    const scriptsLocation = serviceTopology.scriptsDomainUrl
    const thirdParty = joinURL.bind(null, scriptsLocation, 'services', 'third-party')

    const getIntegrationPath = function () { //eslint-disable-line func-style
      return isLocal(window.santaBase) ?
                '//localhost:4578' :
                '//s3.amazonaws.com/integration-tests-statics/SNAPSHOT/runners'
    }

    const paths = {
      platformUtils: './node_modules/santa-platform-utils/dist/platformUtils-bundle',
      coreUtilsLib: 'node_modules/santa-core-utils/dist/coreUtils',
      mobileCore: 'node_modules/santa-mobile-core/dist/mobileCore',
      mobileLayoutUtils: 'node_modules/santa-mobile-core/dist/mobileLayoutUtils',
      imageClientLib: 'node_modules/santa-core-utils/dist/imageClientApi',
      wixImmutable: 'node_modules/santa-core-utils/dist/wixImmutable',
      lodash: thirdParty(`lodash/${versions.lodash}/lodash.min`),
      react: { min: thirdParty(`react/${versions.react}/react-with-addons.min`), source: `//cdnjs.cloudflare.com/ajax/libs/react/${versions.react}/react-with-addons` },
      reactDOM: { min: thirdParty(`react/${versions.react}/react-dom.min`), source: `//cdnjs.cloudflare.com/ajax/libs/react/${versions.react}/react-dom` },
      reactDOMServer: { min: thirdParty(`react/${versions.react}/react-dom-server.min`), source: `//cdnjs.cloudflare.com/ajax/libs/react/${versions.react}/react-dom-server` },
      zepto: { min: thirdParty('zepto/1.2.0/zepto.min'), source: thirdParty('zepto/1.2.0/zepto') },
      speakingurl: thirdParty('speakingurl/speakingurl.min'),
      immutable: {
        min: thirdParty('immutable/3.7.5/dist/immutable.min'),
        source: thirdParty('immutable/3.7.5/dist/immutable')
      },
      mousetrap: thirdParty('mousetrap/1.4.6/mousetrap.min'),
      swfobject: thirdParty('swfobject/2.3.20130521/swfobject.min'),
      TweenMax: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/TweenMax.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/TweenMax`) },
      TweenLite: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/TweenMax.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/TweenMax`) },
      TimelineMax: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/TweenMax.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/TweenMax`) },
      ScrollToPlugin: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/plugins/ScrollToPlugin.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/plugins/ScrollToPlugin`) },
      DrawSVGPlugin: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/plugins/DrawSVGPlugin.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/plugins/DrawSVGPlugin`) },
      MorphSVGPlugin: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/plugins/MorphSVGPlugin.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/plugins/MorphSVGPlugin`) },
      Draggable: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/utils/Draggable.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/utils/Draggable`) },
      color: thirdParty('color-convert/0.2.0/color.min'),
      hammer: thirdParty('hammerjs/2.0.8/hammer.min'),
      jasmine: thirdParty('jasmine/2.1.3/jasmine'),
      'jasmine-html': thirdParty('jasmine/2.1.3/jasmine-html'),
      'jasmine-boot': thirdParty('jasmine/2.1.3/jasmine-boot'),
      bluebird: { min: thirdParty('bluebird/2.9.4/bluebird.min'), source: thirdParty('bluebird/2.9.4/bluebird') },
      SoundManager: thirdParty('soundmanager2/V2.97a.20150601/soundmanager2-nodebug-jsmin'),
      'date-fns': { min: thirdParty('date-fns/v1.3.0/date_fns.min'), source: thirdParty('date-fns/v1.3.0/date_fns') },
      ajv: { min: thirdParty('ajv/4.8.1/ajv.min'), source: thirdParty('ajv/4.8.1/ajv.bundle') },
      ReactProxy: 'js/vendor/ReactProxy',
      Squire: 'js/vendor/squire/Squire',
      io: 'https://cdnjs.cloudflare.com/ajax/libs/socket.io/1.4.0/socket.io.min',
      hot: './node_modules/santa-utils/common/hot/listener',
      'wix-fullstory-loader': './node_modules/wix-fullstory-loader/dist/statics/app.bundle',
      patcher: './node_modules/santa-utils/common/hot/patcher',
      fake: 'js/plugins/fake/src/main/fake',
      definition: 'js/plugins/definition/src/main/definition',
      jsonpatch: 'js/vendor/json-patch/json-patch.umd',
      xss: { min: thirdParty('xss/0.2.12/xss.min'), source: thirdParty('xss/0.2.12/xss') },
      immutableDiff: 'js/vendor/immutablejsdiff.min',
      pmrpc: thirdParty('pm-rpc/1.0.4/pm-rpc.min'),
      remoteDOM: thirdParty('remote-dom/1.0.0/remoteDOM.min'),
      'ag-grid': { min: thirdParty('ag-grid/6.2.1/dist/ag-grid.min'), source: thirdParty('ag-grid/6.2.1/dist/ag-grid') },
      mobx: { min: `js/vendor/mobx/${versions.mobx}/mobx.umd.min`, source: `js/vendor/mobx/${versions.mobx}/mobx.umd` },
      'mobx-react': { min: `js/vendor/mobx/${versions.mobxReact}/mobx-react.min`, source: `js/vendor/mobx/${versions.mobxReact}/mobx-react` }
    }
    if (!experiment) {
      paths.experiment = 'js/plugins/experiment/experiment'
    }

    return {
      //By default load any module IDs from js/lib
      baseUrl: '/',
      //except, if the module ID starts with "app",
      //load it from the js/app directory. paths
      //config is relative to the baseUrl, and
      //never includes a ".js" extension since
      //the paths config could be for a directory.
      paths,
      map: {
        'mobx-react': {
          'react-dom': 'reactDOM'
        }
      },
      // generated
      packages: [{
        name: 'tpaIntegration',
        main: 'tpaIntegration',
        location: getIntegrationPath() + '/tpaIntegration/src/main'
      },
      {
        name: 'wixCodeIntegration',
        main: 'wixCodeIntegration',
        location: getIntegrationPath() + '/wixCodeIntegration/src/main'
      }],
      bundles: null,
      shim: {
        zepto: { exports: '$' },
        color: { exports: 'Color' },
        'jasmine-html': {
          deps: ['jasmine']
        },
        'jasmine-boot': {
          deps: ['jasmine', 'jasmine-html']
        },
        bluebird: { exports: 'bluebird' },
        SoundManager: { exports: 'soundManager' },
        ReactProxy: {
          deps: ['react'],
          exports: 'ReactProxy'
        },
        jsonpatch: { exports: 'jsonpatch' },
        xss: { exports: 'filterXSS' }
      },
      waitSeconds: 0
    }
  }
  return getViewerRjsConfig
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/rjs-config.js